<template>
  <div>
    <div
      style="text-align: center; height: 100vh; display: flex; justify-content: center; align-items: center;"
    >
      <img
        src="/welcome_img.png"
        alt="Welcome"
        style="max-width: 100%; max-height: 100%; width: auto; height: auto;"
      />
    </div>
  </div>
</template>

<style scoped>
.red-statistic .ant-statistic-content-value {
  color: #ff4d4f !important; /* 亮红色 */
  font-weight: bold;
  font-size: 36px;
}
</style>

<script>
import { homeOverview } from "@/api/statistic";
import dayjs from 'dayjs';
import request from '@/utils/request';
import Cookies from 'js-cookie';
import axios from 'axios';

export default {
  
  data() {
    return {
      loading: false,
      item: {},
      teamId: null,  // 新增属性，存储团队ID
    };
  },
    
};
</script>

<style scoped></style>
